import { render, staticRenderFns } from "./NavigationMicrosite.vue?vue&type=template&id=b785b2aa&scoped=true&"
import script from "./NavigationMicrosite.vue?vue&type=script&lang=ts&"
export * from "./NavigationMicrosite.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationMicrosite.vue?vue&type=style&index=0&id=b785b2aa&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b785b2aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VBtn,VIcon,VImg,VMenu,VSpacer,VTabs,VToolbarTitle})
